import { Box, useColorModeValue } from "@chakra-ui/react";
import Header from "./header";

const DashboardHeader = () => {
  const bg = useColorModeValue("#fff", "gray.800");
  
  return (
    <Box
      p={6}
      top={0}
      zIndex={9}
      height={24}
      bgColor={bg}
      display="flex"
      position="sticky"
      alignItems="center"
      borderBottomLeftRadius={10}
    >
      <Header />
    </Box>
  );
};

export default DashboardHeader;
